(() => {
  const button = document.querySelector('[data-custom-scroll-to-top]');
  if (!button) return;

  const launcherSelector = '#reamaze-widget';
  const launcherGap = 12;
  let observedLauncher = null;
  let launcherResizeObserver = null;

  const updateVisibility = () => {
    button.hidden = window.scrollY <= 0;
  };

  const updateLauncherClearance = () => {
    const launcher = document.querySelector(launcherSelector);
    if (!launcher) {
      observedLauncher = null;
      launcherResizeObserver?.disconnect();
      launcherResizeObserver = null;
      button.style.setProperty('--custom-scroll-to-top-launcher-clearance', '0px');
      return;
    }

    if (launcher !== observedLauncher) {
      launcherResizeObserver?.disconnect();
      observedLauncher = launcher;
      if (typeof ResizeObserver === 'function') {
        launcherResizeObserver = new ResizeObserver(updateLauncherClearance);
        launcherResizeObserver.observe(launcher);
      }
    }

    const launcherRect = launcher.getBoundingClientRect();
    const isVisible = launcherRect.height > 0 && launcherRect.top < window.innerHeight;
    const clearance = isVisible
      ? Math.max(0, Math.ceil(window.innerHeight - launcherRect.top + launcherGap))
      : 0;

    button.style.setProperty(
      '--custom-scroll-to-top-launcher-clearance',
      `${clearance}px`
    );
  };

  window.addEventListener('scroll', updateVisibility, { passive: true });
  window.addEventListener('resize', updateLauncherClearance, { passive: true });

  button.addEventListener('click', () => {
    const main = document.querySelector('#MainContent');
    const prefersReducedMotion = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    if (main) {
      if (!main.hasAttribute('tabindex')) main.setAttribute('tabindex', '-1');
      main.focus({ preventScroll: true });
    }
  });

  if (document.body && typeof MutationObserver === 'function') {
    const launcherMutationObserver = new MutationObserver(updateLauncherClearance);
    launcherMutationObserver.observe(document.body, { childList: true, subtree: true });
  }

  updateVisibility();
  updateLauncherClearance();
})();
